import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {DeviceConfigurationModel} from '../../../models/configuration/device-configuration.model';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoTableActionsEnum, TdoTableModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
// import {TableViewData} from '../../../modules/configuration/enterprise-information/enterprise-information.component';
import {Globals} from '../../../globals';
import {DevicesService} from '../../../modules/configuration/devices/devices.service';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {TdoTableBaseItemModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table-base-item.model';
import {ITdoTableItemModel} from '../../../tdo-controls/common/tdo-table/interfaces/i-tdo-table-item.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
  CalibrationParameters,
  DeviceParameters,
  WorkstationDevicesConfigurationModel
} from '../../../models/configuration/workstation-devices-configuration.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TdoTableComponent} from '../../../tdo-controls/common/tdo-table/tdo-table.component';
import {ITdoTable} from '../../../tdo-controls/common/tdo-table/interfaces/i-tdo.table';

export class TableViewData extends TdoTableBaseItemModel implements ITdoTableItemModel {
  actions = [TdoTableActionsEnum.DELETE];
  Name: string;
  model: DeviceConfigurationModel;

  getActionTooltip(actionName: string): string {
    const tooltip = '';
    return tooltip;
  }
}

@Component({
  selector: 'app-imaging-calibration',
  templateUrl: './imaging-calibration.component.html',
  styleUrls: ['./imaging-calibration.component.scss']
})
export class ImagingCalibrationComponent implements OnInit, ITdoTable {
  @ViewChild('deviceTable') deviceTable: TdoTableComponent;
  isErrorFindingDevices: true;
  devices: any;
  selectedDevice: any;
  deviceName: string;
  isLoading: false;
  deviceList: DeviceConfigurationModel[] = [];
  // Table
  tableModel: TdoTableModel;
  displayedColumns: string[] = ['Name'];
  displayedColumnsLabels: string[] = ['Device'];
  dataSource: MatTableDataSource<TableViewData>;
  selection = new SelectionModel<TableViewData>(false, []);
  tableViewData: TableViewData[];
  sourceLength: number;
  rulerLength: number;
  deviceId: string;
  calibrationParam: CalibrationParameters;
  editedDevices: DeviceConfigurationModel[] = [];
  isConfirmDisabled: true;

  constructor(private globals: Globals,
              private devsService: DevicesService,
              public dialogRef: MatDialogRef<ImagingCalibrationComponent>,
              private snackbar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.deviceId = this.data.deviceId;
    this.rulerLength = this.data.rulerLength;
    this.sourceLength = this.data.sourceLength;
    console.log('in Calibration this.deviceId ' + this.deviceId);
    console.log('in Calibration this.sourceLength ' + this.sourceLength);
    console.log('in Calibration this.rulerLength ' + this.rulerLength);
    this.devsService.getDevices(this.globals.LOCID).subscribe((data) => {
      if (data.length > 0) {
        console.log('this.deviceId ' + this.deviceId);
        if (this.deviceId) {
          this.selectedDevice = data.find(p => p.enumDeviceSBID === this.deviceId);
          this.deviceName = this.selectedDevice.Name;
          // this.selectedDevice = data.find(p => p.DeviceID === this.deviceId);
          this.selectedDevice.CalibrationJSON = this.stringifyCalibrationParam();
          // this.deviceTable.selectRow(this.selectedDevice.Name);
          this.onCalibrationChange(this.selectedDevice);
        }
        else {
          this.selectedDevice = data[0];
        }
        if (!this.rulerLength && !this.sourceLength) {
          if (this.selectedDevice.CalibrationJSON) {
            this.getCalibrationFromJSON(this.selectedDevice.CalibrationJSON);
          }
        }
        else {
          console.log(this.selectedDevice.CalibrationJSON);
        }
        // load tdo table
        this.refreshTableViewData(data);
      }
    }, err => {
      console.log(err);
    });
  }
  refreshTableViewData(models: DeviceConfigurationModel[]) {
    this.deviceList = models;

    this.tableViewData = Array.from(this.deviceList, (_) => {
      const model = new TableViewData();
      model.Name = _.Name;
      // model.isSelected = _.TDOCID === this.selectedClient.TDOCID;
      model.model = _;
      return model;
    });
    if (!this.tableModel) {
      this.dataSource = new MatTableDataSource(this.tableViewData);
      this.tableModel = new TdoTableModel(this.displayedColumns, this.displayedColumnsLabels, this.dataSource, 'Name', 'asc');
      this.tableModel.searchPredicate = (data: TableViewData, filter: string) => {
        if (data.Name.toLowerCase().includes(filter)) {
          return true;
        }
      };
    }
    else {
      (this.dataSource as MatTableDataSource<TableViewData>).data = this.tableViewData;
      (this.dataSource as MatTableDataSource<TableViewData>)._updateChangeSubscription();
    }
  }
  getCalibrationFromJSON(paramJson: string) {
    this.calibrationParam = JSON.parse(paramJson);
    console.log('this.calibrationParam.rulerLength' + this.calibrationParam.rulerLength);
    console.log('this.calibrationParam.sourceLength' + this.calibrationParam.sourceLength);
    this.rulerLength = this.calibrationParam.rulerLength;
    this.sourceLength = this.calibrationParam.sourceLength;
  }
  stringifyCalibrationParam() {
    const cal = new CalibrationParameters();
    cal.rulerLength = this.rulerLength;
    cal.sourceLength = this.sourceLength;
    return JSON.stringify(cal);
  }
  onCalibrationChange(selectedDevice: DeviceConfigurationModel) {
    selectedDevice.CalibrationJSON = this.stringifyCalibrationParam();
    if (this.editedDevices !== null) {
      if (!this.editedDevices.includes(selectedDevice)) {
        this.editedDevices.push(selectedDevice);
      }
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }

  onNew($event: any) {
    this.rulerLength = 1;
    this.sourceLength = 1;
  }

  onSave($event: any) {
    this.devsService.saveDevices(this.editedDevices).subscribe((res) => {
      if (res) {
        for (const r of res) {
          const currentIdx = this.deviceList.findIndex(p => p.DeviceID === r.DeviceID);
          if (currentIdx > -1) {
            this.deviceList[currentIdx] = r;
          } else {
            this.deviceList.push(r);
          }
        }
        this.selectedDevice = res[0];
      }

      this.deviceList.sort((a, b) => a.Name.localeCompare(b.Name));

      this.snackbar.open('Calibration saved.', '', {duration: 5000});
      this.isLoading = false;
      this.editedDevices = [];
    });

  }

  onDeviceRowSelected($event: TdoTableSelectionEvent) {

  }

  onTdoTableItemActionClick($event: any) {

  }

  onTdoTableItemClick(event: any) {
    const row = event.value as TableViewData;
    /*if (this.saveDisabled) {
      this.selectedClient = row.model;
    }*/
    this.selectedDevice = row.model;
    // this.populateForm();
  }
  populateForm() {
    console.log('calibration ' + this.selectedDevice.CalibrationJSON);
    if (this.selectedDevice.CalibrationJSON) {
      // populate form
      this.getCalibrationFromJSON(this.selectedDevice.CalibrationJSON);
    }
    else {
      // calibration is null
      this.rulerLength = null;
      this.sourceLength = null;
    }
  }

  onModelChange(selectedDevice: any) {

  }
}
